import { environment } from '../../environments/environment';

export const apiParameters = {
  url: environment.api.url,
  urlOnly: environment.api.urlOnly,
}